mutation DispatchListProfiles(
  $agentRegistrationId: ID!
  $serverUrl: String!
) {
  dispatchListProfiles(
    input: {
      agentRegistrationId: $agentRegistrationId
      serverUrl: $serverUrl
    }
  ) {
    workItem {
      id
      databaseId
      status
    }
    errors
  }
}
